import { Button, Icon } from '@data-products-and-ai/react-components';
import { useLocation, useNavigate, generatePath } from 'react-router';
import { FC } from 'react';
import classnames from 'classnames';

interface BackButtonProps {
  className?: string;
  label?: string;
  url: string;
  from?: string | null;
  preferHistory?: boolean;
}

export const BackButton: FC<BackButtonProps> = ({
  url,
  label,
  className,
  from,
  preferHistory = false,
}) => {
  const navigate = useNavigate();
  const location = useLocation();
  const classNames = classnames('back-button', className);
  const locationState = location.state as { from?: string } | null;
  const backUrl = from ?? locationState?.from;

  const handleClick = () => {
    if (backUrl) {
      navigate(backUrl);
      return;
    }

    if (preferHistory && window.history.length > 1) {
      navigate(-1);
      return;
    }

    navigate(generatePath(url));
  };

  return (
    <div className={classNames}>
      <Button
        type="primaryNoShadow"
        size="small"
        allCaps={false}
        icon={
          <Icon
            icon="IconArrowLeft"
            iconSize={0.75}
            color="var(--color-white)"
          />
        }
        onClick={handleClick}
      >
        {label || 'Back'}
      </Button>
    </div>
  );
};
